import { Link, Navigate, useParams } from 'react-router-dom';
import { darkTheme } from '../../lib/tokens';
import { findPipeline } from './data';
import { PipelineBody } from './components/PipelineBody';

/**
 * Detailansicht einer Strecke im Admin-Rahmen (CUR-1571).
 *
 * Ein unbekannter Slug fuehrt zurueck zur Uebersicht statt auf eine
 * Fehlerseite — im Termin ist ein vertippter Link kein Grund, etwas
 * Kaputtes zu zeigen.
 */
export function PipelineDetailPage(): JSX.Element {
  const { slug } = useParams<{ slug: string }>();
  const doc = findPipeline(slug);

  if (!doc) return <Navigate to="/pipelines" replace />;

  return (
    <div className="mx-auto max-w-5xl">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <Link to="/pipelines" className="text-xs text-text-tertiary hover:text-accent-light">
            ← Alle Strecken
          </Link>
          <h1 className="mt-1 text-2xl font-bold text-text-primary">{doc.title}</h1>
        </div>
        <Link
          to={`/present/pipelines/${doc.slug}`}
          className="rounded-md px-3 py-2 text-xs font-semibold text-text-primary transition-colors hover:brightness-110"
          style={{ background: darkTheme.colors.accent }}
          title="Ohne Seitenleiste und ohne Kontodaten — für die Vorführung"
        >
          Präsentieren
        </Link>
      </header>

      <div className="mt-5">
        <PipelineBody doc={doc} />
      </div>
    </div>
  );
}
